import { render, staticRenderFns } from "./CaseChooser.vue?vue&type=template&id=28e61018&"
import script from "./CaseChooser.vue?vue&type=script&lang=ts&"
export * from "./CaseChooser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports